(function ($) {
  $.ajaxSetup({
    headers: {
      "X-CSRF-Token": Joomla.getOptions("csrf.token"),
    },
  });
})(jQuery);
